module.exports = __webpack_public_path__ + "img/FHWP_axe.3fa5706e.png";